"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createPortalContainer = exports.portalContainerClass = exports.isInPortal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _cobalt_design = require("@cobalt/cobalt_design");

var _positioningHelper = require("../helpers/positioning-helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var portalContainerClass = 'co-portal-container';
exports.portalContainerClass = portalContainerClass;

var isInPortal = function isInPortal(event) {
  var targetClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'co-portal-container';
  var path = event.path || event.composedPath && event.composedPath();
  return path ? path.filter(function (child) {
    return child.className && child.className.indexOf(targetClass) >= 0;
  }).length : false;
};

exports.isInPortal = isInPortal;

var createPortalContainer = function createPortalContainer(componentType) {
  var containerEl = document.getElementById("".concat(portalContainerClass, "--").concat(componentType, "_").concat(_cobalt_design.COBALT_SELECTOR));
  if (containerEl) return containerEl.firstChild;
  var portal = document.createElement('div');
  portal.id = "".concat(portalContainerClass, "--").concat(componentType, "_").concat(_cobalt_design.COBALT_SELECTOR);
  portal.classList.add(_cobalt_design.COBALT_SELECTOR, _cobalt_design.COBALT_COMPATIBILITY_MODIFIER);
  var portalContent = document.createElement('div');
  portalContent.classList.add(portalContainerClass);
  portal.appendChild(portalContent);
  portal.style.height = '0';
  document.body.appendChild(portal);
  return portalContent;
};

exports.createPortalContainer = createPortalContainer;

var Portal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal(_props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Portal).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "loop", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          loop = _assertThisInitialize.loop,
          state = _assertThisInitialize.state;

      var position = props.position,
          target = props.target,
          container = props.container,
          componentType = props.componentType,
          targetRef = props.targetRef;
      var newPosition = (0, _positioningHelper.calculateOptimalWindowPosition)(position, _this.state.position || position, targetRef.current, _this.window, target);

      if (_this.state.position !== newPosition) {
        _this.setState({
          position: newPosition
        });
      }

      var windowPosition = (0, _positioningHelper.calculateWindowPosition)(_this.state.position, container, componentType);
      var isVisible = (0, _positioningHelper.calculateIntersection)(_this.state.position, target, _this.portal);

      if ((0, _lodash.default)(state.windowPosition, windowPosition)) {
        if (!isVisible) {
          _this.props.close();

          return;
        }
      } else {
        _this.setState({
          windowPosition: windowPosition
        });
      }

      _this.loopId = _this.window.requestAnimationFrame(loop);
    });

    _defineProperty(_assertThisInitialized(_this), "startLoop", function () {
      if (_this.loopId) return;
      _this.loopId = _this.window.requestAnimationFrame(_this.loop);
    });

    _defineProperty(_assertThisInitialized(_this), "stopLoop", function () {
      _this.window.cancelAnimationFrame(_this.loopId);
    });

    var _position = _props.position,
        _container = _props.container,
        _componentType = _props.componentType;
    _this.state = {
      defaultPosition: _position,
      position: _position,
      windowPosition: (0, _positioningHelper.calculateWindowPosition)(_position, _container, _componentType)
    };
    _this.portal = createPortalContainer(_componentType);
    _this.window = {
      requestAnimationFrame: function requestAnimationFrame(args) {
        return window.requestAnimationFrame(args);
      },
      cancelAnimationFrame: function cancelAnimationFrame(args) {
        return window.cancelAnimationFrame(args);
      }
    };
    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startLoop();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopLoop();
    }
  }, {
    key: "render",
    value: function render() {
      return _reactDom.default.createPortal((0, _react.cloneElement)(this.props.children, {
        windowPosition: this.state.windowPosition
      }), this.portal);
    }
  }]);

  return Portal;
}(_react.default.Component);

Portal.propTypes = {
  type: _propTypes.string,

  /** {---} click target that will trigger the opening of the @@Portal@@ */
  target: _propTypes.any,
  container: _propTypes.any,

  /** {---} click target that will trigger the opening of the @@<Portal>@@ */
  position: _propTypes.string,
  close: _propTypes.func
};
Portal.defaultProps = {
  close: function close() {}
};
var _default = Portal;
exports.default = _default;
Portal.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "loop",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "startLoop",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "stopLoop",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Portal",
  "props": {
    "close": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "target": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "{---} click target that will trigger the opening of the @@Portal@@"
    },
    "container": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "position": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "{---} click target that will trigger the opening of the @@<Portal>@@"
    }
  }
};